export const PARENT_ROUTES = {
  alarms: { path: "/alarms", labelKey: "menu.alarms" },
  overview: { path: "/", labelKey: "menu.overview" },
  deployment: { path: "/deployment", labelKey: "menu.deployment" }
} as const;

export type Parent = keyof typeof PARENT_ROUTES;

export const isParent = (value: unknown): value is Parent => typeof value === "string" && value in PARENT_ROUTES;
